import React from "react";
import { ContentLayout, HeaderBreadcrumbs, Loader } from "../../../shared";
import { useManageCategorySeo } from "../hooks/useManageCategorySeo";
import { useLocation, useParams } from "react-router-dom";
import { Card, Stack, Typography } from "@mui/material";
import InputControl from "../../../shared/components/InputControl";
import { LoadingButton } from "@mui/lab";

export const ManageCategorySeo = () => {
  const { categoryId } = useParams();
  const {
    formValidator,
    state,
    isEditable,
    handleUpdateSeo,
    handleFormChange,
  } = useManageCategorySeo({ detailsPage: false });
  const location = useLocation();

  const breadcrumbs = [
    { name: "Dashboard", href: "/" },
    { name: "Category", href: "/category" },
    { name: location.state?.name, href: `/category/details/${categoryId}` },
    { name: "Edit" },
  ];

  const helperTexts = {
    slug: formValidator.current.message(
      "slug",
      state.seoDetails.slug,
      "required"
    ),
    meta_title: formValidator.current.message(
      "meta_title",
      state.seoDetails.meta_title,
      "required"
    ),
  };

  return (
    <ContentLayout
      title={location.state?.name}
      breadcrumbs={<HeaderBreadcrumbs links={breadcrumbs} />}
      rightContent={
        isEditable && (
          <LoadingButton
            loading={state.updateButtonLoading}
            variant="contained"
            onClick={handleUpdateSeo}
            disabled={!state.isFormUpdated}
          >
            Update
          </LoadingButton>
        )
      }
    >
      {state.isFormDetailsLoading ? (
        <Stack height="300px" alignItems="center" justifyContent="center">
          <Loader />
        </Stack>
      ) : (
        <Card sx={{ py: "32px", px: "24px" }}>
          <Stack flexDirection="row" justifyContent="space-between" gap="32px">
            <Stack width="20%">
              <Typography fontWeight={600} fontSize={"16px"}>
                SEO
              </Typography>
            </Stack>
            <Stack flex={1} gap="20px">
              <InputControl
                name="slug"
                label="URL Slug"
                required
                value={state.seoDetails.slug}
                onChange={handleFormChange}
                error={Boolean(helperTexts.slug)}
                helperText={helperTexts.slug}
              />
              <InputControl
                name="meta_title"
                label="Meta Title"
                required
                value={state.seoDetails.meta_title}
                onChange={handleFormChange}
                error={Boolean(helperTexts.meta_title)}
                helperText={helperTexts.meta_title}
              />
              <InputControl
                name="header"
                label="H1 Tag"
                value={state.seoDetails.header}
                onChange={handleFormChange}
              />
              <InputControl
                type="textarea"
                rows={4}
                name="meta_description"
                label="Meta Description"
                value={state.seoDetails.meta_description}
                onChange={handleFormChange}
              />
            </Stack>
          </Stack>
        </Card>
      )}
    </ContentLayout>
  );
};
